<template>
  <TemplateLogin>
    <div slot="body">
      <b-form-group class="text-left">
        <label class="label-login">E-mail</label>
        <b-form-input
          id="inputName"
          v-model="entity.login"
          class="login-input"
          :class="{ 'is-invalid': missingLogin }"
        ></b-form-input>
      </b-form-group>
      <b-form-group class="text-left mb-0">
        <label class="label-login">Senha</label>
        <b-input-group class="password-group">
          <b-form-input
            id="inputPassword"
            :type="showPassword ? 'text' : 'password'"
            v-model="entity.password"
            v-on:keyup.enter="login()"
            class="login-input login-input-password"
            :class="{ 'is-invalid': missingPassword }"
          ></b-form-input>
          <b-input-group-append>
            <b-button class="password-toggle-button" @click="showPassword = !showPassword" tabindex="-1">
              <b-icon :icon="showPassword ? 'eye-slash' : 'eye'"></b-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <div class="text-left label-login mt-2 mb-3 fw-500">
        <router-link
          id="linkForgot"
          title="Esqueci a senha"
          class="primary-color"
          :to="{ name: 'forgotpassword' }"
          
          >Esqueci a senha</router-link
        >
      </div>

      <div id="cf-turnstile" class="text-center mt-3 mb-3" data-size="flexible"></div>
      <div v-if="loginError" class="text-danger text-center mb-2">{{ loginError }}</div>
      <!-- <b-button
        block
        style="background-color: #0188F8; border-color: #0188F8;"
        id="btnLogin"
        class="login-button mb-3"
        :disabled="buttonDisabled"
        @click.prevent="login()"
        >{{ turnstileLoading ? 'Aguardando verificação...' : 'Entrar' }}</b-button
      > -->
      <b-button
        block
        style="background-color: #0188F8; border-color: #0188F8;"
        id="btnLogin"
        class="login-button mb-3"
        :disabled="buttonDisabled"
        @click.prevent="login()"
        >Entrar</b-button
      >
      <a
      href="https://wa.me/+553140424391?text=Olá preciso de ajuda para acessar meu mapa"
      class="w-100"
      target="_blank"
      >
      <b-button block variant="success" class="mb-3">
          <img class="img-icon" src="../../assets/img/whatsapp.svg" alt />
          <span class="whatsapp">Fale conosco</span>
      </b-button> </a>
      
    </div>
  </TemplateLogin>
</template>

<script>
import { mapActions } from "vuex";
import md5 from "js-md5";
import TemplateLogin from "../../template/TemplateLogin";
import request, { setTokenHeader } from "../../request/request";
import { tokenStore } from "../../components/extra/LocalStorage";
import { loginPath } from "../../router/ApiPaths";
import socket from "../../socket"

export default {
  name: "LoginScreen",
  props: ["extra"],
  data() {
    return {
      entity: {},
      showPassword: false,
      turnstileResponse: null,
      turnstileLoading: true,
      loginError: '',
    };
  },
  extends: request,
  components: {
    TemplateLogin,
  },
  mounted() {
    // this.loadTurnstile();
  },
  methods: {
    getTurnstileSiteKey() {
      const hostname = window.location.hostname;
      // Adicione aqui as chaves específicas para cada ambiente
      const siteKeys = {
        'localhost': '0x4AAAAAAAiVMV-ncw0CzSDk', // Chave para desenvolvimento
        '127.0.0.1': '0x4AAAAAAAiVMV-ncw0CzSDk',
        'responsively-app': '0x4AAAAAAAiVMV-ncw0CzSDk', // Para ResponsivelyApp
        'default': '0x4AAAAAAAiVMV-ncw0CzSDk' // Chave padrão
      };
      
      // Verifica se está rodando no ResponsivelyApp ou outros webviews
      if (navigator.userAgent.includes('Electron') || 
          hostname.includes('responsively') ||
          hostname === '' ||
          hostname === 'localhost' ||
          hostname === '127.0.0.1') {
        return siteKeys['localhost'];
      }
      
      return siteKeys[hostname] || siteKeys['default'];
    },
    loadTurnstile() {
      this.turnstileLoading = true;
      this.turnstileResponse = null;
      this.loginError = '';
      
      // Remove script se já existir
      const oldScript = document.querySelector('script[src="https://challenges.cloudflare.com/turnstile/v0/api.js"]');
      if (oldScript) oldScript.remove();
      
      // Remove widget anterior se existir
      const oldWidget = document.querySelector('#cf-turnstile > div');
      if (oldWidget) oldWidget.remove();
      
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        window.turnstileCallback = (token) => {
          this.turnstileResponse = token;
          this.turnstileLoading = false;
        };
        
        window.turnstileErrorCallback = (error) => {
          console.warn('Turnstile error:', error);
          this.turnstileLoading = false;
          // Em caso de erro, permite login sem turnstile em desenvolvimento
          if (this.isDevelopment()) {
            this.turnstileResponse = 'dev-bypass-token';
          }
        };
        
        window.turnstileExpiredCallback = () => {
          this.turnstileResponse = null;
          this.turnstileLoading = false;
        };
        
        if (window.turnstile) {
          try {
            window.turnstile.render('#cf-turnstile', {
              sitekey: this.getTurnstileSiteKey(),
              callback: window.turnstileCallback,
              'error-callback': window.turnstileErrorCallback,
              'expired-callback': window.turnstileExpiredCallback,
              'refresh-expired': 'auto',
              'action': 'login',
              'appearance': 'always',
              'execution': 'render'
            });
          } catch (error) {
            console.error('Erro ao carregar Turnstile:', error);
            window.turnstileErrorCallback(error);
          }
        }
      };
      
      script.onerror = () => {
        console.error('Erro ao carregar script do Turnstile');
        this.turnstileLoading = false;
        if (this.isDevelopment()) {
          this.turnstileResponse = 'dev-bypass-token';
        }
      };
      
      document.head.appendChild(script);
    },
    isDevelopment() {
      const hostname = window.location.hostname;
      return hostname === 'localhost' || 
             hostname === '127.0.0.1' || 
             hostname === '' ||
             navigator.userAgent.includes('Electron') ||
             process.env.NODE_ENV === 'development';
    },
    login() {
      this.loginError = '';
      
      // if (this.turnstileLoading) {
      //   this.loginError = 'Aguardando carregamento do CAPTCHA. Por favor, aguarde.';
      //   return;
      // }
      
      // if (!this.turnstileResponse) {
      //   if (this.isDevelopment()) {
      //     console.warn('Modo desenvolvimento: prosseguindo sem Turnstile');
      //     this.turnstileResponse = 'dev-bypass-token';
      //   } else {
      //     this.loginError = 'Por favor, complete o CAPTCHA.';
      //     return;
      //   }
      // }

      this.baseRequest("post", loginPath, {
        login: this.entity.login,
        password: md5(this.entity.password),
        "cf-turnstile-response": this.turnstileResponse
      })
        .then((data) => {
          setTokenHeader(data.token);
          this.setLogin({ user: data, token: data.token });
          tokenStore.set(data.token);
          socket(data.private, data.global);
          this.$router.push({ path: "/" });
        })
        .catch((err) => {
          if (window.turnstile && window.turnstile.reset) {
            try {
              window.turnstile.reset();
            } catch (resetError) {
              console.warn('Erro ao resetar Turnstile:', resetError);
              // Recarrega o widget em caso de erro
              // this.loadTurnstile();
            }
          }
          // this.loginError = err.message || 'Erro no login. Tente novamente.';
        });
    },
    ...mapActions({
      setLogin: "setLogin",
    }),
  },
  computed: {
    missingLogin: function () {
      return !this.entity.login;
    },
    missingPassword: function () {
      return !this.entity.password;
    },
    // buttonDisabled: function () {
    //   if (this.isDevelopment() && !this.turnstileLoading) {
    //     return this.missingLogin || this.missingPassword;
    //   }
    //   return this.missingLogin || this.missingPassword || this.turnstileLoading || !this.turnstileResponse;
    // },
    buttonDisabled: function () {      
      return this.missingLogin || this.missingPassword;
    },
  },
};
</script>

<style lang="sass" scoped>
.label-login
  display: block
  margin-bottom: 0.5rem
  color: #ffffff
  font-size: 12px
  font-weight: 600
  text-transform: uppercase

.login-input
  height: 38px
  min-height: 38px
  padding: 0.375rem 0.75rem
  border-radius: 0.25rem
  font-size: 1rem
  line-height: 1.5

.password-group
  display: flex
  align-items: stretch

.login-input-password
  border-top-right-radius: 0
  border-bottom-right-radius: 0

.password-toggle-button
  display: flex
  align-items: center
  justify-content: center
  width: 46px
  min-width: 46px
  height: 38px
  padding: 0
  background-color: #0188F8
  border-color: #0188F8
  border-top-left-radius: 0
  border-bottom-left-radius: 0

.password-toggle-button:hover,
.password-toggle-button:focus,
.password-toggle-button:active
  background-color: #0188F8 !important
  border-color: #0188F8 !important
  box-shadow: none !important

.whatsapp
  color: #ffffff
  margin-left: 5px

.img-icon
  width: 20px

.login-button
  height: 38px

.login-button:disabled 
  color: #a9a9a9

@media only screen and (max-width: 770px)
  .mobile-card
    display: none
</style>
